import { i18n } from 'src/i18n';
import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';
//import {PdfCalendario} from 'src/modules/shared/pdf/pdfCalendario';
import IncidentService from 'src/modules/incident/incidentService';
import { appendSpanishWeekdayIfBlumar } from 'src/modules/incident/incidentDateWeekday';
import { computeIncidentDerivedFromDates } from 'src/modules/incident/incidentDerivedFields';
import {
  formatIncidentSubTableRowsAsPlainText,
  formatIncidentSubTableRowsForExport,
  formatIncidentSubTableRowsForExportForIncidentRowsPath,
  getIncidentSubTableDefByIncidentRowsPath,
} from 'src/modules/incident/incidentSubTable';
import { incidentExporterFieldsForTenant } from 'src/modules/incident/list/incidentListExporterFields';
import selectors from 'src/modules/incident/list/incidentListSelectors';
import moment from 'moment-timezone';

const prefix = 'INCIDENT_LIST';

const incidentListActions = {
  SELECTED_MODULE: `${prefix}_SELECTED_MODULE`,

  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,
  SET_HAS_FILTER: `${prefix}SET_HAS_FILTER`,

  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  PATCH_RECORD: `${prefix}_SET_RECORD`,

  doSelectModule: (module) => async (dispatch, getState) => {
    dispatch({
      type: incidentListActions.SELECTED_MODULE,
      payload: { module },
    });
    //dispatch(incidentListActions.doFetchCurrentFilter()); // no es necesario, se hace reset desde el listFilter
  },

  doClearAllSelected() {
    return {
      type: incidentListActions.CLEAR_ALL_SELECTED,
    };
  },

  doToggleAllSelected() {
    return {
      type: incidentListActions.TOGGLE_ALL_SELECTED,
    };
  },

  doToggleOneSelected(id) {
    return {
      type: incidentListActions.TOGGLE_ONE_SELECTED,
      payload: id,
    };
  },

  doReset:
    (emptyValues = {}) =>
      async (dispatch) => {
        dispatch({
          type: incidentListActions.RESETED,
          payload: emptyValues,
        });

        dispatch(incidentListActions.doFetchCurrentFilter());
      },

  normalizeNumberLegacy(value) {
    if (value === undefined || value === null || value === '') return '';
    if (typeof value === 'number' && Number.isFinite(value)) return String(Math.trunc(value));
    const match = String(value).match(/-?\d+/);
    if (!match) return '';
    const parsed = parseInt(match[0], 10);
    if (Number.isNaN(parsed)) return '';
    return String(parsed >= 0 ? parsed : 0);
  },

  splitWorkArea(row) {
    const source = row?.workArea?.label || '';
    if (source) {
      const parts = source
        .split('\\')
        .map((part) => part.trim())
        .filter(Boolean);
      return {
        area1: parts[0] || '',
        area2: parts[1] || '',
        area3: parts[2] || '',
      };
    }
    return {
      area1: row?.mainArea || '',
      area2: row?.area || '',
      area3: row?.subArea || '',
    };
  },

  splitIncidentLocation(row) {
    const source = row?.incidentLocation?.label || row?.incidentLocation?.nombre || '';
    if (!source) {
      return {
        ubicacionIncidente1: '',
        ubicacionIncidente2: '',
        ubicacionIncidente3: '',
        ubicacionIncidente4: '',
        ubicacionIncidente5: '',
      };
    }
    const parts = source
      .split('\\')
      .map((part) => part.trim())
      .filter(Boolean);
    return {
      ubicacionIncidente1: parts[0] || '',
      ubicacionIncidente2: parts[1] || '',
      ubicacionIncidente3: parts[2] || '',
      ubicacionIncidente4: parts[3] || '',
      ubicacionIncidente5: parts[4] || '',
    };
  },

  mapExportRow(row) {
    const derived = computeIncidentDerivedFromDates(row);
    const defFromRowsPath = getIncidentSubTableDefByIncidentRowsPath('testigosRows');
    const entrevistasDef = getIncidentSubTableDefByIncidentRowsPath('entrevistasRows');
    const entrevistasRows = Array.isArray(row?.entrevistasRows) ? row.entrevistasRows : undefined;
    const subTableRows =
      defFromRowsPath && Array.isArray(row?.[defFromRowsPath.incidentRowsPath])
        ? row[defFromRowsPath.incidentRowsPath]
        : undefined;
    const { area1, area2, area3 } = incidentListActions.splitWorkArea(derived);
    const {
      ubicacionIncidente1,
      ubicacionIncidente2,
      ubicacionIncidente3,
      ubicacionIncidente4,
      ubicacionIncidente5,
    } = incidentListActions.splitIncidentLocation(derived);
    return {
      division: row?.division || '',
      incidentCode: row?.incidentCode || '',
      employeeName: row?.fullName || row?.employee?.fullName || '',
      registrationNumber: row?.registrationNumber || row?.employee?.registrationNumber || '',
      email: row?.email || '',
      codeSheet: row?.codeSheet || '',
      withLostDays: row?.withLostDays === true ? 'CTP' : 'STP',
      incidentDate: row?.incidentDate
        ? appendSpanishWeekdayIfBlumar(row.incidentDate, 'DD-MM-YYYY HH:mm', AuthCurrentTenant.get())
        : '',
      reportDate: row?.reportDate ? moment(row.reportDate).format('DD-MM-YYYY HH:mm') : '',
      submissionDate: row?.submissionDate ? moment(row.submissionDate).format('DD-MM-YYYY HH:mm') : '',
      dateFrom: row?.dateFrom ? moment(row.dateFrom).format('DD-MM-YYYY') : '',
      dateTo: row?.dateTo ? moment(row.dateTo).format('DD-MM-YYYY') : '',
      nombreJefatura: row?.responsibleAdvisor?.fullName || row?.responsibleAdvisorName || '',
      rutJefatura: row?.responsibleAdvisor?.registrationNumber || '',
      ubicacionIncidente1,
      ubicacionIncidente2,
      ubicacionIncidente3,
      ubicacionIncidente4,
      ubicacionIncidente5,
      centroTrabajo: row?.locations?.[0]?.label || '',
      area1,
      area2,
      area3,
      finalClassification: row?.finalClassification
        ? i18n(`entities.incident.enumerators.finalClassification.${row.finalClassification}`)
        : '',
      causaInmediata1: row?.causaInmediata1 || '',
      causaInmediata2: row?.causaInmediata2 || '',
      causaInmediata3: row?.causaInmediata3 || '',
      causaBasica1: row?.causaBasica1 || '',
      causaBasica2: row?.causaBasica2 || '',
      causaBasica3: row?.causaBasica3 || '',
      medidasControl: row?.medidasDeControl || '',
      testigos:
        Array.isArray(subTableRows) && subTableRows.length && defFromRowsPath
          ? formatIncidentSubTableRowsAsPlainText(subTableRows, defFromRowsPath)
          : '',
      testigosRows:
        Array.isArray(subTableRows) && defFromRowsPath
          ? formatIncidentSubTableRowsForExport(subTableRows, defFromRowsPath.columnTemplates)
          : '',
      tipoRiesgo: row?.tipoRiesgo || '',
      familiaRiesgo: row?.familiaRiesgo || '',
      riesgo: row?.riesgo || '',
      codigoRiesgo: row?.codigoRiesgo || '',
      injuredZone: row?.injuredZone || '',
      injuredZoneSpecific: row?.injuredZoneSpecific || '',
      gender: row?.gender || '',
      birthDate: row?.birthDate ? moment(row.birthDate).format('DD-MM-YYYY') : '',
      ageYears: incidentListActions.normalizeNumberLegacy(derived?.ageYears ?? derived?.age),
      nationality: row?.nationality || '',
      jobPosition: row?.jobPosition || '',
      contractType: row?.contractType
        ? i18n(`entities.incident.enumerators.contractType.${row.contractType}`)
        : '',
      contractStartDate: (derived?.jobStartDate || derived?.contractStartDate)
        ? moment(derived?.jobStartDate || derived?.contractStartDate).format('DD-MM-YYYY')
        : '',
      workExperienceYears: incidentListActions.normalizeNumberLegacy(
        derived?.workExperienceYears ?? derived?.workExperience,
      ),
      workExperienceMonths: incidentListActions.normalizeNumberLegacy(derived?.workExperienceMonths),
      workExperienceDays: incidentListActions.normalizeNumberLegacy(derived?.workExperienceDays),
      companyStartDate: (derived?.companyStartDate || derived?.contractStartDate)
        ? moment(derived?.companyStartDate || derived?.contractStartDate).format('DD-MM-YYYY')
        : '',
      companyExperienceYears: incidentListActions.normalizeNumberLegacy(derived?.companyExperienceYears),
      companyExperienceMonths: incidentListActions.normalizeNumberLegacy(derived?.companyExperienceMonths),
      companyExperienceDays: incidentListActions.normalizeNumberLegacy(derived?.companyExperienceDays),
      horaSiniestro: row?.horaSiniestro || '',
      incidentLocationName: row?.incidentLocation?.label || row?.incidentLocation?.nombre || '',
      incidentStatus: row?.incidentStatus
        ? i18n(`entities.incident.enumerators.incidentStatus.${row.incidentStatus}`)
        : '',
      isInvestigating: row?.isInvestigating ? 'Sí' : 'No',
      incidentDescription: row?.incidentDescription || '',
      // internoSuceso deprecado, usar severity (row.severity ?? row.internoSuceso para compat)
      severity: (row?.severity ?? row?.internoSuceso)
        ? i18n(`entities.incident.enumerators.severity.${row.severity ?? row.internoSuceso}`)
        : '',
      narrativeAccount: row?.narrativeAccount || '',
      contactPhone: row?.contactPhone || '',
      directManagerPosition: row?.directManagerPosition || '',
      propertyDamage: row?.propertyDamage === true ? 'Sí' : row?.propertyDamage === false ? 'No' : '',
      workPerformed: row?.workPerformed || '',
      atSea: row?.atSea === true ? 'Sí' : row?.atSea === false ? 'No' : '',
      causingAgent: row?.causingAgent || '',
      injuryType: row?.injuryType
        ? i18n(`entities.incident.enumerators.injuryType.${row.injuryType}`)
        : '',
      narratorName: row?.narratorName || '',
      narratorRole: row?.narratorRole || '',
      causalEffect: row?.causalEffect || '',
      causalProblem: row?.causalProblem || '',
      causalCause1: row?.causalCause1 || '',
      causalCause2: row?.causalCause2 || '',
      causalCause3: row?.causalCause3 || '',
      investigationConclusion: row?.investigationConclusion || '',
      entrevistasRows:
        Array.isArray(entrevistasRows) && entrevistasDef
          ? formatIncidentSubTableRowsForExport(entrevistasRows, entrevistasDef.columnTemplates)
          : '',
      incidentWeekday: row?.incidentWeekday
        ? i18n(`entities.incident.enumerators.weekday.${row.incidentWeekday}`)
        : '',
      tipoAccidente: Array.isArray(row?.tipoAccidente) ? row.tipoAccidente.filter(Boolean).join(', ') : '',
      accionesSubestandar: Array.isArray(row?.accionesSubestandar) ? row.accionesSubestandar.filter(Boolean).join(', ') : '',
      condicionesSubestandar: Array.isArray(row?.condicionesSubestandar)
        ? row.condicionesSubestandar.filter(Boolean).join(', ')
        : '',
      medidasControlRows: formatIncidentSubTableRowsForExportForIncidentRowsPath(
        row?.medidasControlRows,
        'medidasControlRows',
      ),
    };
  },

  doExport: () => async (dispatch, getState) => {
    try {
      const fieldsForExport = incidentExporterFieldsForTenant(AuthCurrentTenant.get());
      if (!fieldsForExport || !fieldsForExport.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: incidentListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await IncidentService.list(filter, selectors.selectOrderBy(getState()), null, null);
      const exportRows = (response.rows || []).map((row) => incidentListActions.mapExportRow(row));

      new Exporter(fieldsForExport, i18n('entities.incident.exporterFileName')).transformAndExportAsExcelFile(exportRows);

      dispatch({
        type: incidentListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: incidentListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePagination: (pagination) => async (dispatch, getState) => {
    dispatch({
      type: incidentListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch(incidentListActions.doFetchCurrentFilter());
  },

  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({
      type: incidentListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(incidentListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (dispatch, getState) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    //console.log('%c⧭ doFetchCurrentFilter', 'color: #e5de73', {filter, rawFilter});
    dispatch(incidentListActions.doFetch(filter, rawFilter, true));
  },

  setHasFilter:
    (filter, atLeastHast: string[] = []) =>
      async (dispatch, getState) => {
        try {
          const hasFilter = !!Object.keys(filter).find((key) => {
            if (atLeastHast.length && !atLeastHast.includes(key)) return false;
            if (Array.isArray(filter[key])) {
              return filter[key].length && filter[key][0];
            }
            return filter[key];
          });
          //console.log('%c⧭ setHasFilter', 'color: #731d1d', {hasFilter, filter});
          dispatch({
            type: incidentListActions.SET_HAS_FILTER,
            payload: { hasFilter, filter },
          });
        } catch (error) {
          Errors.handle(error);
          dispatch({
            type: incidentListActions.FETCH_ERROR,
          });
        }
      },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
      async (dispatch, getState) => {
        try {
          dispatch({
            type: incidentListActions.FETCH_STARTED,
            payload: { filter, rawFilter, keepPagination },
          });

          const response = await IncidentService.list(
            filter,
            selectors.selectOrderBy(getState()),
            selectors.selectLimit(getState()),
            selectors.selectOffset(getState()),
          );
          // for(let row of response.rows){
          //   row.children = response.rows.map(row => { return {...row}});
          //   for(let rowb of row.children){
          //     rowb.children = row.children.map(row => { return {...row}});
          //     for(let rowc of rowb.children){
          //       rowc.children = rowb.children.map(row => { return {...row}});
          //     }
          //   }
          // }
          dispatch({
            type: incidentListActions.FETCH_SUCCESS,
            payload: {
              rows: response.rows,
              count: response.count,
            },
          });
        } catch (error) {
          Errors.handle(error);

          dispatch({
            type: incidentListActions.FETCH_ERROR,
          });
        }
      },
};

export default incidentListActions;
